/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgWarningTriangle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.95175 2.66487C8.56313 1.88504 7.43708 1.88504 7.04846 2.66487L2.19173 12.4106C1.84987 13.0966 2.34692 13.92 3.14338 13.92H12.8568C13.6533 13.92 14.1503 13.0966 13.8085 12.4106L8.95175 2.66487ZM5.18682 1.73713C6.34107 -0.579044 9.65914 -0.579045 10.8134 1.73713L15.6701 11.4829C16.7109 13.5714 15.1763 16 12.8568 16H3.14338C0.823893 16 -0.710681 13.5714 0.330093 11.4829L5.18682 1.73713L6.11764 2.201L5.18682 1.73713ZM8.00015 5.73177C8.57452 5.73177 9.04015 6.19739 9.04015 6.77177V8.77861C9.04015 9.35299 8.57452 9.81861 8.00015 9.81861C7.42577 9.81861 6.96015 9.35299 6.96015 8.77861V6.77177C6.96015 6.19739 7.42577 5.73177 8.00015 5.73177ZM8.00011 10.749C8.57448 10.749 9.04011 11.2147 9.04011 11.789V11.8693C9.04011 12.4437 8.57448 12.9093 8.00011 12.9093C7.42573 12.9093 6.96011 12.4437 6.96011 11.8693V11.789C6.96011 11.2147 7.42573 10.749 8.00011 10.749Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgWarningTriangle
